module.exports = __webpack_public_path__ + "static/media/good-times2.e149f59c.jpg";